<app-layout>
    <div class="form-configurator-page">
        <mat-toolbar class="page-header" role="heading">
            <div class="page-header-copy">
                <span class="eyebrow" appLocalizationPopupDirective localizationCode="FormConfigurator">
                    {{ 'FormConfigurator' | translate: {Default: "Form Configurator"} }}
                </span>
                <h1>{{ formName || ('FormConfiguratorUntitledForm' | translate: {Default: "Untitled form"}) }}</h1>
            </div>

            <div class="header-actions">
                <button class="header-button" mat-stroked-button routerLink="{{routes.SITE_SETTINGS}}{{routes.FORMS}}">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">arrow_back</mat-icon>
                    {{ 'FormConfiguratorBackToForms' | translate: {Default: "Back to forms"} }}
                </button>

                <button class="header-button" mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="elementsDisplay.openDemoFormDialog()">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">preview</mat-icon>
                    {{ 'FormConfiguratorPreview' | translate: {Default: "Preview"} }}
                </button>

                <button class="header-button" mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="elementsDisplay.addElement()">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon>
                    {{ 'FormConfiguratorAddElement' | translate: {Default: "Add element"} }}
                </button>
            </div>
        </mat-toolbar>

        <div class="main-content">
            <app-form-elements-display
                #elementsDisplay
                class="canvas"
                [formId]="formId"
                (formLoaded)="onFormLoaded($event)"
            ></app-form-elements-display>

            <app-form-details-form
                class="settings"
                [formId]="formId"
                (saved)="onFormLoaded($event)"
            ></app-form-details-form>
        </div>
    </div>
</app-layout>
